import React from 'react'
import { Badge } from '@pdrj/pmi-iqos-ds-react'

const SpotsUsageBadge = ({ spot, usageTypes, noBg }) => {
  const spotUsageType =
    usageTypes &&
    usageTypes.find(element => parseInt(element.id) === spot.iqosFreeType)
  const spotUsage = spotUsageType ? spotUsageType.name : ''
  return spotUsage ? (
    <Badge
      text={spotUsage}
      defaultBg={
        noBg
          ? Badge.defaultBackgrounds.white
          : Badge.defaultBackgrounds.colorContext
      }
    />
  ) : null
}

export default SpotsUsageBadge
